import React, { useMemo, useReducer } from 'react';

import { ExpandMore } from '@mui/icons-material';
import { Collapse } from '@mui/material';

import { useStyles } from './styles';

type Props = {
    body: string;
    collapsible?: boolean;
    className?: string;
};

const headingToId = (txt: string) => txt.toLowerCase().replace(/[^\w]+/g, '-');

const Toc: React.FC<Props> = ({ body, collapsible, className }) => {
    const { classes, cx } = useStyles();
    const [open, toggleOpen] = useReducer((state) => !state, false);
    const headings = useMemo(() => [...body.matchAll(/^##\s+(.*)$/gm)].map(([_, match]) => match), [body]);

    return (
        <aside className={cx(classes.root, className)}>
            {headings.length > 0 ? (
                <p className={classes.title} onClick={toggleOpen}>
                    {'On this page'}
                    {collapsible ? <ExpandMore className={cx(classes.icon, { [classes._rotated]: open })} /> : null}
                </p>
            ) : null}
            <Collapse in={collapsible ? open : true} className={classes.collapse} unmountOnExit mountOnEnter>
                {headings.map((heading, index) => (
                    <a key={index} href={`#${headingToId(heading)}`} className={classes.link}>
                        {heading}
                    </a>
                ))}
            </Collapse>
        </aside>
    );
};

export default Toc;
